<template>
  <v-dialog
    v-model="dialog"
    max-width="400"
    persistent
  >
    <v-card>
      <v-card-title class="text-h6">
        <font-awesome-icon
          :icon="['fas', 'pen']"
          class="mr-2 primary--text"
        />
        Rename Filter
      </v-card-title>

      <v-card-text class="pb-0">
        <v-form
          ref="form"
          v-model="isValid"
        >
          <v-text-field
            v-model="filterName"
            label="Filter Name"
            :rules="[rules.required, rules.maxLength]"
            outlined
            dense
            autofocus
            counter="50"
            hint="Update the filter name"
            persistent-hint
            @keyup.enter="save"
          >
            <template v-slot:prepend-inner>
              <font-awesome-icon
                :icon="['fas', 'tag']"
                class="mr-1"
                size="sm"
              />
            </template>
          </v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!isValid"
          :loading="saving"
          @click="save"
        >
          <font-awesome-icon
            :icon="['fas', 'check']"
            class="mr-2"
            size="sm"
          />
          Rename
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RenameFilterDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      filterName: '',
      isValid: false,
      saving: false,
      rules: {
        required: (v) => !!v || 'Filter name is required',
        maxLength: (v) => (v && v.length <= 50) || 'Name must be 50 characters or less',
      },
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },

  watch: {
    dialog(newVal) {
      if (newVal && this.filter) {
        this.filterName = this.filter.name || ''
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.resetValidation()
          }
        })
      }
    },
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.saving = true

      try {
        // Update only the name, preserve existing filter values
        await this.$store.dispatch('savedFilters/updateFilter', {
          id: this.filter.id,
          updates: {
            name: this.filterName,
          },
        })

        this.dialog = false
        this.filterName = ''
      } catch (error) {
        // Error handled by store action
      } finally {
        this.saving = false
      }
    },

    cancel() {
      this.dialog = false
      this.filterName = ''
    },
  },
}
</script>
